import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-view401',
  templateUrl: './view401.component.html',
  styleUrls: ['./view401.component.css']
})
export class View401Component implements OnInit {
  msg = '';
  
  constructor(private routeLocation: ActivatedRoute) { 
   this.msg = this.routeLocation.snapshot.queryParams.msg;
  }

  getConfig() {
    if (this.msg && this.msg !== ''){
      $("#control_div").height('100%');
      $("#control_div").css('background-color', '#e5e5e6');
    } else {
      this.msg = 'Acceso denegado al recurso.';
    }
  }

  ngOnInit() {
    this.getConfig();
  }

}
